const heroAboutPegasus = {
  title: 'Pegasus Arms LLC',
  paragraphs: [
    'A Ukrainian defense technology company that develops, manufactures, and implements strike unmanned aerial systems (UAS) resistant to electronic warfare (EW). Founded in 2023, the company has become one of the key drivers of the miltech sector, working side by side with the Defense Forces of Ukraine.',
    'We make Ukrainian technology a reliable weapon that helps save the lives of defenders and gain an advantage on the battlefield. We supply Ukrainian units with strike UAVs capable of performing combat missions effectively even under intense electronic warfare — without GPS or external control.',
  ],
}

export default heroAboutPegasus
